import React, { Component } from 'react'
import axios from 'axios'
import FormMitraEnergi from '../components/FormMitraEnergi'

export default class Form extends Component {
    constructor() {
        super();
        this.state = {
            users: []
        }
    }

    componentDidMount() {
        console.log('1----ini akan dipasang');
        const url = 'https://jsonplaceholder.typicode.com/users';
        axios.get(url).then((user) => 
        this.setState({
            users: user.data
        }))
    }

    render() {
        console.log('2---ini sedang dipasang');
        return (
            <div>
                <FormMitraEnergi />
                {/* <div>
                    { this.state.users.map((users, index) => {
                        return (
                            <div key={index}>
                                {users.name}
                            </div>
                        )
                    })}
                </div> */}
            </div>
        )
    }
}
